import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { BoxChartSeries, NgxChartsModule } from '@swimlane/ngx-charts';
import { Period, PriceMatcherService, Pricing, PricingSearchParams, Product } from 'src/app/services/pricematcher.service';

@Component({
    selector: 'historical-pricing',
    standalone: true,
    imports: [NgxChartsModule, RouterLink],
    templateUrl: './historical-pricing.component.html',
    styleUrl: './historical-pricing.component.css'
})
export class HistoricalPricingComponent implements OnInit {

  params: PricingSearchParams;
  product: Product;
  pricing: Pricing[];
  latestPrice: Pricing;
  graphData: BoxChartSeries[];


  constructor(private service: PriceMatcherService, private route: ActivatedRoute) { }

  async rangeSelection(range: string) {
    switch (range) {
      case 'DAY':
        this.params.range = Period.DAY;
        break;
      case 'WEEK':
        this.params.range = Period.WEEK;

        break;
      case 'MONTH':
        this.params.range = Period.MONTH;

        break;
      case 'YEAR':
        this.params.range = Period.YEAR;

        break;
      default:
        this.params.range = Period.ALL;

        break;

    }
    this.pricing = await this.service.getPricingHistory(this.params);
  }

  async loadData() {
    this.pricing = await this.service.getPricingHistory(this.params);
    this.product = await this.service.searchProduct(this.params.upc);
    this.graphData = this.service.generateData(this.pricing);
  }

  async ngOnInit(): Promise<void> {
    this.pricing = [];
    this.params = new PricingSearchParams();
    this.product = new Product();
    this.latestPrice = new Pricing();
    this.graphData = [];
    //this.product = this.service.getDummyProduct();
    //this.graphData = this.service.getDummyData();

    this.route.queryParams.subscribe(async params => {
      this.params.page = 0;
      this.params.size = 10;
      this.params.upc = params['upc'];
      if (this.params.upc) {
        this.loadData();
      }


    });




  }

}
